import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'

const ServiceDetails = (props) => {
    const rows = []
    if (props.details) {
        props.details.forEach((item, key) => {
            rows.push([item.title, item.value])
        })
    }

    return (
        <div className='service-details module'>
            <Heading title={props.title} />
            <div className='module-inner p-4'>
                <div className='row'>
                    <div className='col-12 col-lg-10 offset-lg-1'>
                        <ResponsiveTable data={{ headings: ['Title', 'Value'], rows: rows }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

ServiceDetails.propTypes = {
    title: PropTypes.string.isRequired,
    details: PropTypes.array
}

export default ServiceDetails



// WEBPACK FOOTER //
// ./resources/js/modules/ServiceDetails.js